import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { UserService } from './user.service';
import { RequestServicio } from '../clases/request-servicio';
import { Router } from '@angular/router';
import { CuentaService } from './cuenta.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfiguracionSolicitar } from '../clases/confgurarListar';
import { AlertService } from './alert.service';
import { environment } from '../../environments/environment';
import { DatosFb } from '../clases/datos-fb';
import { Campos } from '../clases/campos';
import { Usuario } from '../clases/usuario';
import { EventEmitter } from '@angular/core';
import { Parametro } from '../clases/Parametro';



@Injectable({
  providedIn: 'root'
})
export class DatosCompartidosService {

  constructor(
    private userService: UserService,
    private router: Router,
    private cuentaService: CuentaService,
    private alertService: AlertService
  ) { }
  public _solicitarServicio = new BehaviorSubject<RequestServicio>(new RequestServicio());
  solicitarServicio$ = this._solicitarServicio.asObservable();

  public _usuario = new BehaviorSubject<Usuario>(new Usuario());
  usuario$ = this._usuario.asObservable();

  public _usuarioPedirVisita = new BehaviorSubject<Usuario>(new Usuario());
  usuarioPedirVisita$ = this._usuario.asObservable();

  public _configuracionSolicitar = new BehaviorSubject<ConfiguracionSolicitar>(new ConfiguracionSolicitar());
  configuracionSolicitar$ = this._configuracionSolicitar.asObservable();

  public _user = new BehaviorSubject<Array<any>>([]);
  user$ = this._user.asObservable();
  public _Parametro = new BehaviorSubject<Array<Parametro>>([]);
  Parametro$ = this._Parametro.asObservable();

  public _Polilyne = new BehaviorSubject<any>([]);
  Polilyne$ = this._Polilyne.asObservable();
  //public _datosFb = new BehaviorSubject<DatosFb>()
  public datosFb$: BehaviorSubject<Array<DatosFb>> = new BehaviorSubject<Array<DatosFb>>([]);
 
  public Deletedatos$ = new EventEmitter<any>();
  public DatosPasajeros$ = new EventEmitter<any>();

  public LimpiarDirecion$ = new EventEmitter<any>();


  guardarUsuario(user: any,token:any): Observable<number> {
    let error: any;
    return this.userService.requestLogin(user,token).pipe(map((data: any) => {
      this.alertService.clear()

      if (data.idResultado == 1) {
        const currentUser = {
          IdCliente: data.cliente.IdCliente,
          Rol: data.cliente.Rol
        }
        localStorage.setItem('currentUser' + '_' + environment.NOMBRE_EMPRESA, JSON.stringify(currentUser));
        this._user.next(data.cliente);

        this.router.navigate(['/default']);

      } else if (data.idResultado == environment.MENSAJES.LOGIN.USUARIO_INACTIVO.CODIGO) {
        //Clave incorrecta
        //this.alertService.error('', environment.MENSAJES.LOGIN.USUARIO_INACTIVO.DESCRIPCION);
        error = environment.MENSAJES.LOGIN.USUARIO_INACTIVO.CODIGO;
      } else if (data.idResultado == environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.CODIGO) {

        // this.alertService.error('', environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.DESCRIPCION);
        error = environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.CODIGO;

      } else if (data.idResultado == environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.CODIGO) {
        // this.alertService.error('', environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.DESCRIPCION);
        error = environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.CODIGO;

      } else if (data.idResultado == environment.MENSAJES.LOGIN.ERROR.CODIGO) {
        // this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
        error = environment.MENSAJES.LOGIN.ERROR.CODIGO;

      }


      return error;

    }));


  }

  iniciarSesionFB(email: string): Observable<any> {
    let resp: any = 2;
    let json = {
      'email': email
    }
    //let usuario;


    return this.userService.validarCorreo(json).pipe(map((data: any) => {
      //  console.log(data);
      if (data.idResultado == 1) {
        const currentUser = {
          IdCliente: data.IdCliente,
          Rol: data.Rol
        }
        this._user.next(data);
        localStorage.setItem('currentUser' + '_' + environment.NOMBRE_EMPRESA, JSON.stringify(currentUser));
        this.router.navigate(['/default']);


      } else if (data.idResultado == -1) {

        this.alertService.error('Error');
        resp = -1;

      } else if (data.idResultado == -2) {

        resp = -2;
      }
      return resp;
    }));



  }

  obtenerUsuario(idUsuario: any): Observable<any> {

    let usuario;


    return this.cuentaService.getUsuario(idUsuario).pipe(map((data: any) => {
      usuario = data;


      this._user.next(usuario);
      // this._user.next(data.cliente);


      // if (usuario.prefijo === null || usuario.prefijo === undefined || usuario.prefijo === '') {
      //   usuario.prefijo = '+51';
      // } else {
      //   usuario.prefijo = '+' + usuario.prefijo;
      // }

      if (usuario.isoCountryCode === undefined || usuario.isoCountryCode === "" || usuario.isoCountryCode === null) {
        usuario.isoCountryCode = 'PE';
      }
      // console.log("isoCountryCode: " + usuario.isoCountryCode);

      if (usuario.camposDinamicos !== undefined && usuario.camposDinamicos !== null) {
        let camposDinamicos = usuario.camposDinamicos;
        // let campos  = {
        //     a: 1,
        //     campoDinamico : this.user.camposDinamicos
        // }
        // this.camposDinamicos = campos.campoDinamico;
        // this.camposDinamicos = this.user.camposDinamicos;

        camposDinamicos.forEach(element => {
          let campo: Campos = new Campos();
          if (element.c === 'COMBO' && element.i.length !== undefined) {
            element.i.splice(0, 0, '--SELECCIONE--')
            campo.t = element.i[0];
          }
        });

      }
      

      return usuario;

    }));


  }

  getDatosFB() {
    // console.log('this.datosFb$');
    return this.datosFb$;
  }

  getDatosRegistroFB() {
    // console.log("get Usuario");

    return this.getDatosFB().pipe(
      map((data: any) => {
        return data;
      })
    );
  }
  updateSolicitar(solicitar: RequestServicio) {
    this._solicitarServicio.next(solicitar)
  }
  updateUsuario(usuario: Usuario) {
    this._usuario.next(usuario)
  }
   

  updateConfiguracionSolicitar(configuracion: ConfiguracionSolicitar) {
    this._configuracionSolicitar.next(configuracion)
  }
}
